module.exports = __webpack_public_path__ + "img/ISO证书.0871a457.svg";